import React from 'react';
import { useField } from 'informed';

import { TextArea } from '@nw/omega-design-system';
import { HelperTextStyledComponent } from '@nw/shared/ui';

import { FieldContainer } from './styledComponents';

interface TextAreaFieldPropTypes {
  label: string;
  field: string;
  error: string;
  touched: boolean;
  isDisabled: boolean;
  validationSchemaObject: any;
  isHidden?: boolean;
  fieldWrapperStyles?: string;
  handleChange?: any;
  helperText?: string;
  inputClassName?: string;
  inputContainerClassName?: string;
  labelClassName?: string;
  rows?: number;
  isMarginBottomZero?: boolean;
  enableDataMask?: boolean;
  placeHolder?: string;
}

const InformedTextAreaField = (props: TextAreaFieldPropTypes) => {
  const {
    label,
    field,
    error,
    touched,
    isDisabled,
    validationSchemaObject,
    isHidden,
    fieldWrapperStyles,
    helperText,
    inputClassName,
    inputContainerClassName,
    labelClassName,
    rows,
    isMarginBottomZero,
    enableDataMask,
    placeHolder
  } = props;

  const { fieldState, render, informed, fieldApi } = useField({
    field,
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: validationSchemaObject.fields[field],
    error: error,
    touched: touched,
    isDisabled
  });
  const { value } = fieldState;
  const { onBlur, onChange } = informed;
  const isNotValid = touched && error ? true : false;
  const { setTouched, setValue } = fieldApi;

  const renderHelperText = () => {
    return helperText ? (
      <HelperTextStyledComponent helperText={helperText} />
    ) : null;
  };

  const renderTextAreaField = () => (
    <TextArea
      label={label}
      handleChange={(e: any) => {
        setValue(e.target.value);
        onChange(e.target.value);
        setTouched(true);
      }}
      handleBlur={(e: any) => {
        onBlur(e.target.value);
      }}
      errorMessage={error}
      hint={renderHelperText()}
      inputClassName={inputClassName}
      inputContainerClassName={inputContainerClassName}
      labelClassName={labelClassName}
      rows={rows}
      enableDataMask={enableDataMask}
      placeholder={placeHolder}
    />
  );

  return render(
    <FieldContainer
      key={field}
      isHidden={isHidden}
      css={fieldWrapperStyles}
      isMarginBottomZero={isMarginBottomZero}
      placeholder={placeHolder}
    >
      {renderTextAreaField()}
    </FieldContainer>
  );
};

export { InformedTextAreaField };
